import {
  subclass,
  property,
} from "@arcgis/core/core/accessorSupport/decorators";

import Widget from "@arcgis/core/widgets/Widget";

import { messageBundle, tsx } from "@arcgis/core/widgets/support/widget";
import { VNode } from "src/interfaces/interfaces";

import "./FeaturedSidebar.scss";

import AppT9N from "../../../t9n/App/App.json";
import NavBarViewModel from "src/app/ui/NavBar/NavBarViewModel";

import SidebarTilePic from "../../../../public/assets/featuredArticle/articleTilePics/SidebarArticle.png";
import ChartViewerTilePic from "../../../../public/assets/featuredArticle/articleTilePics/ChartViewerArticle.png";
import ThemingTilePic from "../../../../public/assets/featuredArticle/articleTilePics/ThemingArticle.jpg";
import InsetsTilePic from "../../../../public/assets/featuredArticle/articleTilePics/Insets_Article.jpg";
import AtlasTilePic from "../../../../public/assets/featuredArticle/articleTilePics/AtlasArticle.png";
import ManagerTilePic from "../../../../public/assets/featuredArticle/articleTilePics/ManagerArticle.png";
import { keyboardAccessibleHelper } from "../../utils/appUtils";

interface IBlogTile {
  imgRef: string;
  headerTitle: string;
  descText: string;
  linkUrl: string;
  linkText: string;
}

interface IArticleTile {
  id: string;
  imgRef: string;
  headerTitle: string;
  descText: string;
}

export const PRODUCT_NAME = "ArcGIS Instant Apps";

@subclass("app.widgets.Sidebar.FeaturedSidebar")
export default class FeaturedSidebar extends Widget {
  //--------------------------------------------------------------------------
  //
  //  Properties
  //
  //--------------------------------------------------------------------------

  @property()
  @messageBundle("dist/assets/t9n/App/App")
  appMessages: typeof AppT9N;

  @property()
  navbarVM: NavBarViewModel;

  //--------------------------------------------------------------------------
  //
  //  Public Methods
  //
  //--------------------------------------------------------------------------

  constructor(args) {
    super(args);
  }

  render() {
    const {
      sidebarArticle,
      sidebarArticleDesc,
      chartViewerArticle,
      chartViewerArticleDesc,
      themingArticle,
      themingArticleDesc,
      insetsArticle,
      insetsArticleDesc,
      atlasArticle,
      atlasArticleDesc,
      managerArticle,
      managerArticleDesc,
    } = this.appMessages.featuredTab;
    return (
      <div class="featured-sidebar">
        <div>
          {this._renderArticleTile({
            id: "manager",
            imgRef: ManagerTilePic,
            headerTitle: managerArticle,
            descText: managerArticleDesc,
          })}
          {this._renderArticleTile({
            id: "atlas",
            imgRef: AtlasTilePic,
            headerTitle: atlasArticle,
            descText: atlasArticleDesc,
          })}
          {this._renderArticleTile({
            id: "insets",
            imgRef: InsetsTilePic,
            headerTitle: insetsArticle,
            descText: insetsArticleDesc,
          })}
          {this._renderArticleTile({
            id: "theming",
            imgRef: ThemingTilePic,
            headerTitle: themingArticle,
            descText: themingArticleDesc,
          })}
          {this._renderArticleTile({
            id: "sidebar",
            imgRef: SidebarTilePic,
            headerTitle: sidebarArticle,
            descText: sidebarArticleDesc,
          })}
          {this._renderArticleTile({
            id: "chartViewer",
            imgRef: ChartViewerTilePic,
            headerTitle: chartViewerArticle,
            descText: chartViewerArticleDesc,
          })}
        </div>
      </div>
    );
  }

  //--------------------------------------------------------------------------
  //
  //  Private Methods
  //
  //--------------------------------------------------------------------------

  private _renderArticleTile(articleTile: IArticleTile): VNode {
    const { imgRef, headerTitle, descText, id } = articleTile;
    return (
      <div
        key={id}
        class={this.classes(
          "article-tile",
          this.navbarVM._featuredArticleStateRouter === id
            ? "article-tile--selected"
            : null
        )}
        onclick={this._handleCarouselSelection.bind(this, id)}
        onkeydown={(e: KeyboardEvent) => {
          if (e.code === "Space") {
            // stop space from scrolling the sidebar down
            e.preventDefault();
          }

          keyboardAccessibleHelper(
            this._handleCarouselSelection.bind(this, id),
            e
          );
        }}
        tabindex="0"
      >
        <img src={imgRef} alt="" class="article-tile-image" />
        <div class="article-tile-info">
          <header class="article-header-text">{headerTitle}</header>
        </div>
      </div>
    );
  }

  private _handleCarouselSelection(id: any): void {
    this.navbarVM._featuredArticleStateRouter = id;
  }
}
